document.addEventListener('DOMContentLoaded', function () {


  new Swiper('.regua-fio-wraper.swiper', {
    slidesPerView: 1,
    spaceBetween: 12,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false
    },
    centeredSlides: false,
    pagination: {
      el: '.regua-fio-wraper .swiper-pagination',
      clickable: true
    },
    breakpoints: {
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 5 }
    }
  });
});
